<template>
  <div class="account_content">
    <div class="account_content_header">
      <div class="account_content_header_title">
        <span>Data Analysis</span>
        <el-button type="text" @click="reSelectDataLink"
          >Re select data</el-button
        >
      </div>
      <div class="account_content_header_tab">
        <div class="account_content_header_tab_item active">
          Company Analysis
        </div>
        <div class="account_content_header_tab_item" @click="linkToAnalysis">
          Enterprise Analysis
        </div>
      </div>
      <div class="account_content_header_box">
        <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
            No. of Companies
          </span>
          <span class="account_content_header_box_item_value">{{
            titleData.companyCount
          }}</span>
        </div>
        <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
           No. of Industries
          </span>
          <span class="account_content_header_box_item_value">{{
            titleData.industryCount
          }}</span>
        </div>
        <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
            Total Countries
          </span>
          <span class="account_content_header_box_item_value">{{
            titleData.countryCount
          }}</span>
        </div>
        <!-- <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
            Industry Prospects
          </span>
          <span class="account_content_header_box_item_value">
            <div>Good {{ titleData.goodIndustryCount }}</div>
            <div>Average {{ titleData.middleIndustryCount }}</div>
            <div>Poor {{ titleData.badIndustryCount }}</div>
            <div>Unknown {{ titleData.unknowIndustryCount }}</div>
          </span>
        </div> -->
      </div>
    </div>
    <div class="account_content_wrapper">
      <div class="account_content_wrapper_list" v-loading="ChiladTableloading">
        <div
          class="account_content_wrapper_list_item"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div class="account_item_title">
            <span class="item_no">{{ index + 1 }}</span>
            <span class="item_title">
              {{ item.isicDesc }}
            </span>
            <i
              class="iconfont icon-lujing"
              :class="item.isShowDetail ? 'active' : ''"
              @click="showDetail(item, index)"
            />
          </div>
          <div class="account_item_content">
            <div class="account_item_content_item">
              <span class="content_item_title">ISIC:</span>
              <span class="content_item_value">{{ item.isicCode }}</span>
            </div>
            <div class="account_item_content_item">
              <span class="content_item_title">
                No. of companies in the region:
              </span>
              <span class="content_item_value">{{
                item.industryTotal | FilterNum
              }}</span>
            </div>
            <div class="account_item_content_item">
              <span class="content_item_title">
                Average Revenue:
              </span>
              <span class="content_item_value">{{
                item.mainBussinessIncome | FilterNum
              }}</span>
            </div>
          </div>
          <div class="account_item_content">
            <div class="account_item_content_item">
              <span class="content_item_title">Country:</span>
              <span class="content_item_value">
                <img
                  v-for="list in item.involveCountry"
                  :src="require('../../../../static' + getCountryImgUrl(list))"
                />
              </span>
            </div>
            <div class="account_item_content_item">
              <span class="content_item_title"> Industry Outlook: </span>
              <span class="content_item_value">{{
                item.industryProspect
              }}</span>
            </div>
          </div>
          <div class="account_item_content" v-show="item.isShowDetail">
            <div class="account_item_content_detail">
              <div class="industry_ranking">
                <div class="detail_item_title">
                  Industry Ranking of Selected Enterprises
                  <el-button
                    type="text"
                    :disabled="selectList.length != 1"
                    @click="searchLeadsLink"
                    >Search Leads</el-button
                  >
                </div>
                <div class="detail_item_search">
                  <el-input
                    class="search-select-con"
                    popper-class="new-search-select"
                    placeholder="Enter Company Name"
                    v-model="searchParams.name"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <el-select
                    clearable
                    v-model="searchParams.date"
                    filterable
                    popper-class="new-search-select"
                    placeholder="Select Update Date"
                    :popper-append-to-body="true"
                  >
                    <el-option
                      v-for="(item, index) in item.updateList"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    clearable
                    v-model="searchParams.country"
                    filterable
                    popper-class="new-search-select"
                    placeholder="Select Country"
                    :popper-append-to-body="true"
                  >
                    <el-option
                      v-for="(item, index) in item.countryList"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    clearable
                    v-model="searchParams.credit"
                    filterable
                    popper-class="new-search-select"
                    placeholder="Select credit Assessment"
                    :popper-append-to-body="true"
                  >
                    <el-option
                      v-for="(item, index) in item.creditList"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    class="reset_btn"
                    @click="resetCompany(item, index)"
                    >Reset</el-button
                  >
                  <el-button
                    class="search_btn"
                    @click="searchCompany(item, index)"
                    >Search</el-button
                  >
                </div>
                <el-table
                  class="risk_table"
                  :data="item.enterpriseIndustryStatusVoList"
                  height="100%"
                  ref="tableRef"
                  :row-key="(row) => row.aaaId"
                  @selection-change="onSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    align="center"
                    class-name="table_check_row"
                    width="40"
                  />
                  <el-table-column
                    prop="rank"
                    align="left"
                    label="Ranking"
                    min-width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="companyName"
                    label="Co. Name"
                    min-width="200"
                  >
                    <template slot-scope="scope">
                      <div class="flex_center_start_box">
                        <span
                          class="link_hover_text"
                          @click="goDetail(scope.row)"
                        >
                          {{ scope.row.companyName }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>

                  <!-- 其他table -->
                  <el-table-column
                    :resizable="false"
                    :prop="col.prop"
                    :column-key="col.prop"
                    :label="col.label"
                    :min-width="col.width"
                    :align="col.align"
                    show-overflow-tooltip
                    v-for="col in showRowList"
                    :key="col.prop"
                  >
                  </el-table-column>
                  <el-table-column align="center" label="" width="40">
                    <template slot="header" slot-scope="scope">
                      <i
                        class="iconfont icon-tianjia1"
                        @click="isShowRowList = !isShowRowList"
                      />
                    </template>
                  </el-table-column>
                </el-table>
                <div class="row_check_box" v-show="isShowRowList">
                  <el-checkbox-group v-model="selectRowListValue">
                    <el-checkbox
                      :label="ops.prop"
                      v-for="(ops, index) in allRowList"
                      :key="index"
                    >
                      {{ ops.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <el-button class="reset_btn" @click="isShowRowList = false"
                    >Cancel</el-button
                  >
                  <el-button class="search_btn" @click="confirmRowSelection"
                    >Confirm</el-button
                  >
                </div>
              </div>
              <div class="industry_description">
                <div class="detail_item_title">Industry Description</div>
                <div class="industry_description_content">
                  <div class="industry_description_content_left">
                    <div class="industry_description_content_list">
                      <div class="industry_description_content_list_label">
                        Industry Title
                      </div>
                      <div class="industry_description_content_list_value">
                        {{ item?.industryDetailVO?.industryTitle || "-" }}
                      </div>
                    </div>
                    <div class="industry_description_content_list">
                      <div class="industry_description_content_list_label">
                        Industry Description
                      </div>
                      <div class="industry_description_content_list_value">
                        {{ item?.industryDetailVO?.industryDescription || "-" }}
                      </div>
                    </div>
                  </div>
                  <div class="industry_description_content_right">
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          ISIC
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.isicCode || "-" }}
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          ISIC Description
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.isicCodeDes || "-" }}
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NACE
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.naceCode || "-" }}
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NACE Description
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.naceCodeDes || "-" }}
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NAICS
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.naicsCode || "-" }}
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NAICS Description
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.naicsCodeDes || "-" }}
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          CSIC
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.csicCode || "-" }}
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          CSIC Description
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.csicCodeDes || "-" }}
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          AAAIC
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.aaaicCode || "-" }}
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          AAAIC Description
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.aaaicCodeDes || "-" }}
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          GICS
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.gicsCode || "-" }}
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          GICS Description
                        </div>
                        <div class="industry_description_content_list_value">
                          {{ item?.industryDetailVO?.gicsCodeDes || "-" }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="industry_observation">
                <div class="detail_item_title">Industry Observations</div>
                <el-table
                  class="risk_table merge_table"
                  :data="item.researchObservations"
                  height="100%"
                  ref="tableRef"
                >
                  <el-table-column prop="name" align="left" label="Comparison">
                  </el-table-column>

                  <el-table-column
                    prop="Average"
                    align="center"
                    label="Average"
                  >
                  </el-table-column>
                  <el-table-column prop="Media" align="center" label="Mean">
                  </el-table-column>
                  <el-table-column prop="Max10" label="Max(10%)" align="center">
                  </el-table-column>
                  <el-table-column prop="Min10" align="center" label="Min(10%)">
                  </el-table-column>
                </el-table>
              </div>
              <div class="industry_stats">
                <div class="detail_item_title">Industry Stats</div>
                <el-table
                  class="risk_table merge_table"
                  :data="item.researchComparison"
                  height="100%"
                  ref="tableRef"
                >
                  <el-table-column
                    prop="name"
                    align="left"
                    label="Industry Stats"
                  >
                  </el-table-column>
                  <el-table-column prop="2023" align="center" label="2023">
                  </el-table-column>
                  <el-table-column prop="2022" align="center" label="2022">
                  </el-table-column>
                  <el-table-column prop="2021" label="2021" align="center">
                  </el-table-column>
                  <el-table-column prop="2020" align="center" label="2020">
                  </el-table-column>
                  <el-table-column prop="2019" align="center" label="2019">
                  </el-table-column>
                </el-table>
              </div>
              <div class="industry_performance">
                <div class="detail_item_title">Industry Performance</div>
                <el-table
                  class="risk_table merge_table"
                  :data="item.researchPerformance"
                  height="100%"
                  ref="tableRef"
                  :row-class-name="
                    (obj) => rowClassName(obj, item.researchPerformance)
                  "
                  :span-method="
                    (obj) => arraySpanMethod(obj, item.researchPerformance)
                  "
                >
                  <el-table-column prop="name" align="left" label="Performance">
                  </el-table-column>
                  <el-table-column
                    prop="proportion"
                    align="left"
                    min-width="130"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="Average"
                    align="center"
                    label="Average"
                  >
                  </el-table-column>
                  <el-table-column prop="Media" align="center" label="Mean">
                  </el-table-column>
                  <el-table-column prop="Max10" label="Max(10%)" align="center">
                  </el-table-column>
                  <el-table-column prop="Min10" align="center" label="Min(10%)">
                  </el-table-column>
                  <!-- <el-table-column
                    prop="performance5"
                    align="center"
                    label="2019"
                  >
                  </el-table-column> -->
                </el-table>
              </div>
              <div class="industry_overview">
                <div class="detail_item_title">Industry Overview</div>
                <div class="industry_overview_text">
                  {{ item.industryOverviewNew?.title }}
                  <div v-for="value in item.industryOverviewNew?.lists">
                    {{ value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination_box">
        <Page
          keyword="Industry Analysis"
          :fontColor="'#1290C9'"
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @onPageChange="onChangePage"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import Page from "@/views/newLayout/page.vue";
import { mixins1 } from "@/mixins/index";
import {
  getIndustryAnalysisStatistics,
  getIndustryAnalysisPageList,
  getAcountAllCompanies,
} from "@/api/userApi";
import { forEach } from "lodash";
export default {
  components: {
    Page,
  },
  mixins: [mixins1],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 1000,
      searchParams: {
        name: "",
        date: "",
        country: "",
        credit: "",
      },
      selectList: [],
      isShowRowList: false,
      selectRowListValue: [
        "updateYear",
        "countryName",
        "mainBussinessIncome",
        "creditGrade",
      ],
      showRowList: [
        {
          label: "Update Date",
          prop: "updateYear",
          align: "center",
          width: 120,
        },
        {
          label: "Country",
          prop: "countryName",
          align: "center",
          width: 120,
        },
        {
          label: "Revenue",
          prop: "mainBussinessIncome",
          align: "center",
          width: 120,
        },
        {
          label: "Credit Assessment",
          prop: "creditGrade",
          align: "center",
          width: 120,
        },
      ],
      allRowList: [
        {
          label: "Update Date",
          prop: "updateYear",
          align: "center",
          width: 120,
        },
        {
          label: "Country",
          prop: "countryName",
          align: "center",
          width: 120,
        },
        {
          label: "Revenue",
          prop: "mainBussinessIncome",
          align: "center",
          width: 120,
        },
        {
          label: "Credit Assessment",
          prop: "creditGrade",
          align: "center",
          width: 120,
        },
        {
          label: "Gross margin (%)",
          prop: "grossMargin",
          align: "center",
          width: 120,
        },
        {
          label: "Return on equity (%)",
          prop: "returnOnEquity",
          align: "center",
          width: 120,
        },
        {
          label: "Current ratio (x)",
          prop: "currentRatio",
          align: "center",
          width: 120,
        },
        {
          label: "Quick ratio (x)",
          prop: "quickRatio",
          align: "center",
          width: 120,
        },
        {
          label: "Debt ratio (%)",
          prop: "debtRatio",
          align: "center",
          width: 120,
        },
      ],
      selectOptions: [
        { value: "option1", label: "Option 1" },
        { value: "option2", label: "Option 2" },
        { value: "option3", label: "Option 3" },
      ],
      tableData: [],
      tableDataCopy: [],
      industryRankingData: [
        {
          aaaId: 1,
          rank: 10,
          companyName: "Company A",
          updateYear: "2024-01-01",
          countryCode: "CN",
          mainBussinessIncome: "USD 101,026 K",
          creditGrade: "AA+",
        },
        {
          aaaId: 2,
          rank: 20,
          companyName: "Company B",
          updateDate: "2024-01-01",
          country: "US",
          mainBussinessIncome: "USD 101,026 K",
          creditGrade: "A",
        },
        {
          aaaId: 3,
          rank: 2023,
          companyName: "Company C",
          country: "JP",
          mainBussinessIncome: "USD 101,026 K",
          creditGrade: "A+",
        },
      ],
      industryObservationData: [
        {
          year: 1,
          name: "Years in Business",
          Average: "3",
          Media: "3",
          Max10: "3",
          Min10: "3",
        },
        {
          year: 2,
          name: "Revenue",
          Average: "2,308",
          Media: "2,308",
          Max10: "2,308",
          Min10: "2,308",
        },
        {
          year: 3,
          name: "Net Earning",
          Average: "78,837",
          Media: "78,837",
          Max10: "78,837",
          Min10: "78,837",
        },
        {
          year: 4,
          name: "Total Assets",
          Average: "78,837",
          Media: "78,837",
          Max10: "78,837",
          Min10: "78,837",
        },
        {
          year: 5,
          name: "Total Liability",
          Average: "78,837",
          Media: "78,837",
          Max10: "78,837",
          Min10: "78,837",
        },
        {
          year: 6,
          name: "Total Net Earning",
          Average: "78,837",
          Media: "78,837",
          Max10: "78,837",
          Min10: "78,837",
        },
        {
          year: 7,
          name: "Total Operating Cost",
          Average: "78,837",
          Media: "78,837",
          Max10: "78,837",
          Min10: "78,837",
        },
        {
          year: 8,
          name: "Return on equity (%)",
          Average: "53.28%",
          Media: "53.28%",
          Max10: "53.28%",
          Min10: "53.28%",
        },
        {
          year: 9,
          name: "Return on Assets (ROA)",
          Average: "104.31%",
          Media: "104.31%",
          Max10: "104.31%",
          Min10: "104.31%",
        },
        {
          year: 10,
          name: "Profit margin (%)",
          Average: "89.78%",
          Media: "89.78%",
          Max10: "89.78%",
          Min10: "89.78%",
        },
        {
          year: 11,
          name: "Gross margin (%)",
          Average: "48.91%",
          Media: "48.91%",
          Max10: "48.91%",
          Min10: "48.91%",
        },
        {
          year: 12,
          name: "Asset turnover (x)",
          Average: "225.76%",
          Media: "225.76%",
          Max10: "225.76%",
          Min10: "225.76%",
        },
      ],
      industryStatsData: [
        {
          aaaId: 1,
          name: "Number of companies in this industry",
          2023: "314,977",
          2022: "314,977",
          2021: "314,977",
          2020: "314,977",
          2019: "314,977",
        },
        {
          aaaId: 2,
          name: "Number of large companies",
          2023: "314,977",
          2022: "314,977",
          2021: "314,977",
          2020: "314,977",
          2019: "314,977",
        },
        {
          aaaId: 3,
          name: "Number of SMEs",
          2023: "314,977",
          2022: "314,977",
          2021: "314,977",
          2020: "314,977",
          2019: "314,977",
        },
        {
          aaaId: 4,
          name: "Number of companies in samples",
          2023: "314,977",
          2022: "314,977",
          2021: "314,977",
          2020: "314,977",
          2019: "314,977",
        },
        {
          aaaId: 5,
          name: "Companies in Loss",
          2023: "314,977",
          2022: "314,977",
          2021: "314,977",
          2020: "314,977",
          2019: "314,977",
        },
        {
          aaaId: 6,
          name: "Geographic Distribution",
          2023: "314,977",
          2022: "314,977",
          2021: "314,977",
          2020: "314,977",
          2019: "314,977",
        },
      ],
      industryPerformance: [
        {
          name: "Profitability Ratios",
          proportion: "Return on equity (%)",
          Average: "42.81%",
          Max10: "42.81%",
          Media: "42.81%",
          Min10: "42.81%",
        },
        {
          name: "Profitability Ratios",
          proportion: "Return on assets (%)",
          Average: "42.81%",
          Max10: "42.81%",
          Media: "42.81%",
          Min10: "42.81%",
        },
        {
          name: "Profitability Ratios",
          proportion: "Profit margin (%)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Profitability Ratios",
          proportion: "Gross margin (%)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Operating Ratios",
          proportion: "Asset turnover (x)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Operating Ratios",
          proportion: "Stock turnover (x)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Operating Ratios",
          proportion: "Sales period (days)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Operating Ratios",
          proportion: "Collection period (days)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Operating Ratios",
          proportion: "Credit period (days)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Structure Ratios",
          proportion: "Current ratio (x)",
          Average: "-5.73%",
          Max10: "-5.73%",
          Media: "-5.73%",
          Min10: "-5.73%",
        },
        {
          name: "Structure Ratios",
          proportion: "Quick ratio (x)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Structure Ratios",
          proportion: "Shareholder liquidity ratio (x)",
          Average: "144.26",
          Max10: "144.26",
          Media: "144.26",
          Min10: "144.26",
        },
        {
          name: "Structure Ratios",
          proportion: "Debt ratio (%)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Productivity Ratios",
          proportion: "Profit per employee (th)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Productivity Ratios",
          proportion: "Operating revenue per employee (th)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Productivity Ratios",
          proportion: "Shareholder funds per employee (th)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Productivity Ratios",
          proportion: "Total assets per employee (th)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Growth Ratios",
          proportion: "Sales Growth Rate (%)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Growth Ratios",
          proportion: "Net Profit Growth Rate (%)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
        {
          name: "Growth Ratios",
          proportion: "Total Assets Growth Rate (%)",
          Average: "-",
          Max10: "-",
          Media: "-",
          Min10: "-",
        },
      ],
      //查询条件
      aaaids: [],
      //title 数据
      titleData: {
        badIndustryCount: "",
        companyCount: "",
        countryCount: "",
        goodIndustryCount: "",
        industryCount: "",
        middleIndustryCount: "",
        unknowIndustryCount: "",
      },
      ChiladTableloading: false,
    };
  },
  beforeDestroy() {},
  watch: {},
  methods: {
    // 能力表现单元格合并
    arraySpanMethod({ row, column, rowIndex, columnIndex }, list) {
      if (columnIndex === 0) {
        let prevRow = list[rowIndex - 1];
        let nextRow = list[rowIndex + 1];

        if (prevRow && row.name == prevRow.name) {
          //当有上一条数据，并且和当前类型相同

          return {
            rowspan: 0,
          };
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow.name == row.name) {
            //当有下一条数据并且和当前类型相同时,获取新的下一条
            countRowspan++;
            nextRow = list[rowIndex + countRowspan];
            // console.log(row, prevRow, nextRow);
          }
          return {
            rowspan: countRowspan,
            colspan: 1,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }; // 默认不合并其他列
    },
    //行头合并
    rowClassName({ row, rowIndex }, list) {
      // 获取能力表现合并行每一组对应的行号
      const data = list || [];
      // 第一行一定是新组
      if (rowIndex === 0) {
        return "line_cell_item";
      }
      const current = data[rowIndex];
      const prev = data[rowIndex - 1];
      // 和上一行不同，说明是新组第一行
      if (prev && current.name !== prev.name) {
        return "line_cell_item";
      }

      return "";
    },
    //翻页
    onChangePage(pagParm) {
      this.currentPage = pagParm.page;
      this.pageSize = pagParm.pageSize;
      this.getIndustryAnalysisPageList();
    },
    //列表展开
    showDetail(item, index) {
      this.resetCompany(item, index);
      item.isShowDetail = !item.isShowDetail;
      this.tableData.forEach((i) => {
        if (i.id !== item.id) {
          i.isShowDetail = false;
        }
      });
    },
    resetDetailTable() {
      this.searchParams = {
        name: "",
        date: "",
        country: "",
        credit: "",
      };
      this.selectList = [];
    },
    // 选择展示的列
    confirmRowSelection() {
      this.showRowList = this.allRowList.filter((item) =>
        this.selectRowListValue.includes(item.prop),
      );
      this.isShowRowList = false;
    },
    // 表格选择改变时
    onSelectionChange(val) {
      this.selectList = val;
      console.log(123, this.selectList);
    },
    //跳转企业分析
    linkToAnalysis() {
      this.$router.push({
        path: "/account/enterpriseAnalysis",
        query: {
          aaaids: this.aaaids.join("@@"),
          // keyword: this.$route.query.keyword,
          // selectKey: this.$route.query.selectKey,
          // type: String(index),
        },
      });
    },
    //行业分析统计
    getIndustryAnalysisStatistics() {
      let param = {
        aaaids: this.aaaids,
      };
      getIndustryAnalysisStatistics(param)
        .then((res) => {
          if (res.code == 200) {
            this.titleData = res.data;
          }
        })
        .catch((err) => {});
    },
    //行业分析列表
    getIndustryAnalysisPageList() {
      this.ChiladTableloading = true;
      let param = {
        page: this.currentPage,
        pageSize: this.pageSize,
        aaaids: this.aaaids,
      };
      getIndustryAnalysisPageList(param)
        .then((res) => {
          if (res.code == 200) {
            this.ChiladTableloading = false;
            this.total = res.data.total;
            let list = res.data.rows;
            //
            let options = list.map((item, index) => {
              //格式化
              item.enterpriseIndustryStatusVoList =
                item.enterpriseIndustryStatusVoList.map((i) => {
                  i.rank = i.rank || "-";
                  i.mainBussinessIncome = this.$options.filters.FilterNum(
                    i.mainBussinessIncome,
                  );
                  return i;
                });
              //update
              let updateList = [];
              updateList = item.enterpriseIndustryStatusVoList.map((i) => {
                return i.updateYear;
              });
              const uniqueBasicArrayupdate = [...new Set(updateList)].filter(
                (item) => item,
              );
              //country
              let countryList = [];
              countryList = item.enterpriseIndustryStatusVoList.map((i) => {
                return i.countryName;
              });
              const uniqueBasicArraycountry = [...new Set(countryList)].filter(
                (item) => item,
              );
              //credit
              let creditList = [];
              creditList = item.enterpriseIndustryStatusVoList.map((i) => {
                return i.creditGrade;
              });
              const uniqueBasicArraycredit = [...new Set(creditList)].filter(
                (item) => item,
              );
              //industry Overview
              let industryOverviewNew = {};
              let industryOverview = item.industryOverview?.split("\n");
              if (industryOverview) {
                const title = industryOverview[0];
                let lists = [];
                industryOverview.forEach((item, index) => {
                  if (index != 0) {
                    lists.push(item.replace("●", ""));
                  }
                });
                industryOverviewNew = { title: title, lists: lists };
              }

              return {
                ...item,
                isShowDetail: false,
                id: index,
                updateList: uniqueBasicArrayupdate,
                countryList: uniqueBasicArraycountry,
                creditList: uniqueBasicArraycredit,
                industryOverviewNew: industryOverviewNew,
              };
            });
            //
            this.tableData = options;
            this.tableDataCopy = list;
            // this.tableData = list.map((item, index) => {
            //   return { ...item, isShowDetail: false, id: index };
            // });
          }
        })
        .catch((err) => {});
    },
    //跳转公司详情
    goDetail(row) {
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaaid +
          "/background/snapshot?id3a=" +
          row.aaaid +
          "&companyCountry=" +
          row.countryCode +
          // "&SACode1=" +
          // SACode1 +
          "&companyName=" +
          row.companyName +
          "&keword=" +
          this.$route.query.keword,
      });
      window.open(routeData.href, "_blank");
    },
    //跳转个人中心
    reSelectDataLink() {
      let routeData = this.$router.resolve({
        path: "/account/companiesViewed?type=1",
      });
      window.open(routeData.href, "_blank");
    },
    //跳转问卷
    searchLeadsLink() {
      console.log(1111, this.selectList);
      let routeData = this.$router.resolve({
        path: "/index/list/risk",
        query: {
          selectCode: 4,
          aaa_id: this.selectList[0].aaaid,
          companyName: this.selectList[0].companyName,
        },
      });
      window.open(routeData.href, "_blank");
    },
    //获取个人中心所有aaaid
    getAcountAllCompanies() {
      getAcountAllCompanies()
        .then((res) => {
          if (res.code == 200) {
            this.aaaids = res.data.map((item) => {
              return item.aaaid;
            });
            //title
            this.getIndustryAnalysisStatistics();
            //
            this.getIndustryAnalysisPageList();
          }
        })
        .catch((err) => {});
    },
    //公司搜索
    searchCompany(Sitem, Sindex) {
      this.selectList = [];
      let searchItem = this.tableDataCopy[
        Sindex
      ].enterpriseIndustryStatusVoList.filter(
        (i) =>
          (this.searchParams.name != ""
            ? i.companyName
                .toLowerCase()
                .includes(this.searchParams.name.toLowerCase())
            : true) &&
          (this.searchParams.date != ""
            ? i.updateYear == this.searchParams.date
            : true) &&
          (this.searchParams.country != ""
            ? i.countryName == this.searchParams.country
            : true) &&
          (this.searchParams.credit != ""
            ? i.creditGrade == this.searchParams.credit
            : true),
      );
      this.tableData.map((item, index) => {
        if (index == Sindex) {
          item.enterpriseIndustryStatusVoList = searchItem;
        }
      });
    },
    //公司搜索 -- 重置
    resetCompany(Sitem, Sindex) {
      this.searchParams = {
        name: "",
        date: "",
        country: "",
        credit: "",
      };
      this.searchCompany(Sitem, Sindex);
    },
  },
  mounted() {
    if (this.$route.query.aaaids) {
      this.aaaids = this.$route.query.aaaids.split("@@") || [];
      //title
      this.getIndustryAnalysisStatistics();
      //
      this.getIndustryAnalysisPageList();
    } else {
      //接口查询
      this.getAcountAllCompanies();
    }
    // this.aaaids = this.$route.query.aaaids || [];
    // //title
    // this.getIndustryAnalysisStatistics();
    // //
    // this.getIndustryAnalysisPageList();
  },
};
</script>
<style scoped>
::v-deep .el-table__body-wrapper {
  height: auto !important;
}
.account_content {
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.account_content_header {
  height: 220px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 20px;
}
.account_content_wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.account_content_header_title {
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.account_content_header_title span {
  font-family: Arial Bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 34px;
  text-align: left;
}
.account_content_header_title .el-button {
  color: #1290c9;
}
.account_content_header_tab {
  width: fit-content;
  margin: 10px auto 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  background: #f5f5f5;
  border-radius: 4px;
}
.account_content_header_tab_item {
  padding: 9px 20px;
  height: 40px;
  font-size: 18px;
  color: #1a2332;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}
.account_content_header_tab_item.active {
  font-family: Arial Bold;
  background: #ffffff;
  border-radius: 4px;
}
.account_content_header_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}
.account_content_header_box_item {
  flex: 1;
  padding: 10px 20px;
  height: 70px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #a2a9b0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
}
.account_content_header_box_item_title {
  font-size: 18px;
  color: #1a2332;
  line-height: 18px;
  text-align: center;
  font-style: normal;
}
.account_content_header_box_item_value {
  width: 100%;
  font-size: 18px;
  color: #1290c9;
  line-height: 18px;
  text-align: center;
  font-style: normal;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.account_content_wrapper_list {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.account_content_wrapper_list_item {
  width: 100%;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 20px 30px 30px 60px;
}
.account_item_title {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}
.item_no {
  font-family: Arial Bold;
  font-size: 24px;
  color: #1290c9;
  text-align: center;
  font-style: normal;
  position: absolute;
  left: -40px;
}
.item_title {
  font-family: Arial Bold;
  font-size: 24px;
  color: #1a2332;
  text-align: left;
  font-style: normal;
}
.account_item_title .icon-lujing {
  font-size: 18px;
  color: #1290c9;
  cursor: pointer;
  transform: rotate(90deg);
  transition: all ease-in-out 0.2s;
}
.account_item_title .icon-lujing.active {
  transform: rotate(270deg);
}
.account_item_content {
  margin-top: 20px;
  display: flex;
  gap: 41px;
}
.account_item_content_item {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
.account_item_content_item + .account_item_content_item::before {
  content: "";
  width: 1px;
  height: 14px;
  background: #dddddd;
  position: absolute;
  left: -20px;
  /* top: 50%;
  transform: translateY(-50%); */
}
.content_item_title {
  font-size: 18px;
  color: #666666;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.content_item_value {
  font-size: 18px;
  color: #1a2332;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.content_item_value img {
  width: 40px;
  height: 24px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
  margin-right: 10px;
}
.account_item_content_detail {
  width: 100%;
  height: auto;
}
.account_item_content_detail > div {
  border-top: 1px solid #a2a9b0;
  padding-top: 30px;
  padding-bottom: 30px;
}
.account_item_content_detail .industry_overview {
  padding-bottom: 0px;
}
.detail_item_title {
  height: 30px;
  font-family: Arial Bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}
.detail_item_title .el-button {
  float: right;
  font-size: 20px;
  /* color: #999999; */
  text-align: right;
  font-style: normal;
  text-decoration-line: underline;
}
.detail_item_search {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  margin-bottom: 20px;
}
.detail_item_search > div {
  flex: 1;
  min-width: 0;
}
.detail_item_search >>> .el-input__inner {
  height: 40px;
  box-sizing: border-box;
}
.reset_btn {
  width: 100px;
  height: 40px;
  background: #eeeeee;
  border-radius: 10px;
  font-size: 18px;
  line-height: 40px;
  color: #1a2332;
  text-align: center;
  font-style: normal;
  margin-left: 10px;
  padding: 0;
}
.search_btn {
  width: 100px;
  height: 40px;
  background: #1290c9;
  border-radius: 10px;
  font-size: 18px;
  line-height: 40px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  margin-left: 0px;
  padding: 0;
}
.icon-tianjia1 {
  cursor: pointer;
  font-size: 20px;
  color: #1290c9;
}
.industry_ranking {
  position: relative;
}
.row_check_box {
  position: absolute;
  top: 170px;
  right: 0;
  padding: 20px;
  width: auto;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
}
.row_check_box .el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}
.row_check_box .reset_btn {
  margin-right: 10px;
}
.industry_description_content {
  display: flex;
  gap: 60px;
}
.industry_description_content_left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.industry_description_content_right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.industry_description_content_item {
  width: 100%;
  height: 108px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 20px;
}
.industry_description_content_list {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.industry_description_content_list_label {
  width: 162px;
  font-family: Arial Bold;
  font-size: 18px;
  color: #1a2332;
  line-height: 26px;
}
.industry_description_content_list_value {
  flex: 1;
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
}
.industry_description_content_left .industry_description_content_list_label {
  width: 118px;
}
.industry_description_content_right .industry_description_content_list_value {
  color: #29445d;
}
.merge_table >>> .el-table__body tr td:first-child {
  background: #f2f5f9;
}
.merge_table >>> .el-table__body .line_cell_item td:nth-child(2) {
  background: #f2f5f9;
}
.merge_table >>> .el-table__body .line_cell_item td:nth-child(1) {
  border-right: 1px solid #cccccc;
}
.industry_overview_text {
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
  text-align: justify;
  font-style: normal;
}
.industry_overview_text div {
  margin-top: 10px;
  padding-left: 16px;
  position: relative;
}
.industry_overview_text div:first-child {
  margin-top: 20px;
}
.industry_overview_text div::before {
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  background: #1a2332;
  border-radius: 50%;
  position: absolute;
  left: 2px;
  top: 12px;
}
.link_hover_text {
  color: #1290c9;
}
.risk_table
  .el-table__body
  tr:hover
  > td.el-table__cell:not(.el-table__expanded-cell)
  .link_hover_text {
  color: #1290c9;
  text-decoration: underline;
}

@media (max-width: 1920px) {
  .account_content {
    gap: 8px;
  }
  .account_content_header {
    height: 170px;
    padding: 14px;
  }
  .account_content_header_title {
    padding-left: 8px;
  }
  .account_content_header_title span {
    font-size: 18px;
    line-height: 26px;
  }
  .account_content_header_tab {
    margin: 8px auto 14px;
    height: 36px;
    padding: 5px 14px;
  }
  .account_content_header_tab_item {
    padding: 7px 14px;
    height: 30px;
    font-size: 14px;
  }

  .account_content_header_box {
    gap: 12px;
  }
  .account_content_header_box_item {
    padding: 8px 14px;
    height: 55px;
  }
  .account_content_header_box_item_title {
    font-size: 14px;
    line-height: 14px;
  }
  .account_content_header_box_item_value {
    font-size: 14px;
    line-height: 14px;
  }
  .account_content_wrapper_list {
    gap: 8px;
  }
  .account_content_wrapper_list_item {
    padding: 14px 22px 22px 44px;
  }
  .account_item_title {
    gap: 8px;
  }
  .item_no {
    font-size: 18px;
    left: -30px;
  }
  .item_title {
    font-size: 18px;
  }
  .account_item_title .icon-lujing {
    font-size: 14px;
  }
  .account_item_content {
    margin-top: 14px;
    gap: 30px;
  }
  .account_item_content_item {
    gap: 8px;
  }
  .account_item_content_item + .account_item_content_item::before {
    height: 12px;
    left: -15px;
  }
  .content_item_title {
    font-size: 14px;
    line-height: 18px;
  }
  .content_item_value {
    font-size: 14px;
    line-height: 18px;
  }
  .content_item_value img {
    width: 30px;
    height: 20px;
    margin-right: 8px;
  }
  .account_item_content_detail > div {
    padding-top: 22px;
    padding-bottom: 22px;
  }
  .detail_item_title {
    height: 22px;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 14px;
  }
  .detail_item_title .el-button {
    font-size: 16px;
  }
  .detail_item_search {
    gap: 8px;
    height: 30px;
    margin-bottom: 14px;
  }
  .detail_item_search >>> .el-input__inner {
    height: 30px;
    font-size: 14px;
  }
  .reset_btn {
    width: 80px;
    height: 30px;
    border-radius: 8px;
    font-size: 14px;
    margin-left: 8px;
    line-height: 30px;
  }
  .search_btn {
    width: 80px;
    height: 30px;
    border-radius: 8px;
    font-size: 14px;
    margin-left: 8px;
    line-height: 30px;
  }
  .icon-tianjia1 {
    font-size: 16px;
  }

  .row_check_box {
    top: 130px;
    padding: 14px;
  }
  .row_check_box .el-checkbox-group {
    gap: 14px;
    margin-bottom: 14px;
  }
  .row_check_box .reset_btn {
    margin-right: 8px;
  }
  .industry_description_content {
    gap: 45px;
  }
  .industry_description_content_left {
    gap: 12px;
  }
  .industry_description_content_right {
    gap: 14px;
  }
  .industry_description_content_item {
    height: 80px;
    padding: 14px;
  }
  .industry_description_content_list {
    gap: 14px;
    margin-bottom: 12px;
  }

  .industry_description_content_list_label {
    width: 126px;
    font-size: 14px;
    line-height: 20px;
  }
  .industry_description_content_list_value {
    flex: 1;
    font-size: 14px;
    line-height: 22px;
  }
  .industry_description_content_left .industry_description_content_list_label {
    width: 85px;
  }

  .industry_overview_text {
    font-size: 14px;
    line-height: 22px;
  }
  .industry_overview_text div {
    margin-top: 8px;
    padding-left: 14px;
  }
  .industry_overview_text div:first-child {
    margin-top: 14px;
  }
  .industry_overview_text div::before {
    width: 5px;
    height: 5px;
    left: 2px;
    top: 9px;
  }
}
</style>
